// frontend/src/services/auth.js
import { API_BASE_URL } from './api';

// Funzione per verificare se il token è valido
export const checkAuth = async () => {
  try {
    const token = localStorage.getItem('authToken');
    
    if (!token) {
      return false;
    }
    
    const response = await fetch(`${API_BASE_URL}/api/auth/me`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
      },
    });
    
    if (!response.ok) {
      // Se il token non è valido, rimuovilo dal localStorage
      localStorage.removeItem('authToken');
      return false;
    }
    
    return true;
  } catch (error) {
    console.error('Errore nella verifica dell\'autenticazione:', error);
    return false;
  }
};

// Funzione per effettuare il login
export const login = async (password) => {
  const response = await fetch(`${API_BASE_URL}/api/auth/login`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ password }),
  });
  
  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.detail || 'Errore durante l\'autenticazione');
  }
  
  const data = await response.json();
  localStorage.setItem('authToken', data.access_token);
  return true;
};

// Funzione per effettuare il logout
export const logout = () => {
  localStorage.removeItem('authToken');
  localStorage.removeItem('currentChatId');
  return true;
};

// Funzione per ottenere il token corrente
export const getToken = () => {
  return localStorage.getItem('authToken');
};